import { render, staticRenderFns } from "./itemGroup.vue?vue&type=template&id=7f433790"
import script from "./itemGroup.vue?vue&type=script&lang=js"
export * from "./itemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports